import {css} from 'styled-components';

export default css`
  --primaryColor: #f59000;
  --primaryBorderColor: #f59000;
  --primaryLightColor: #fff6ea;
  --primaryThBorderColor: #f5d1a1;
  --primaryBgcolor: #fbeedc;

  --secondaryColor: #f59000;
  --secondaryBorderColor: #f59000;
  --secondaryLightColor: #fff6ea;
  --secondaryThBorderColor: #f5d1a1;
  --thirdColor: #f59000;
  --thirdBorderColor: #f59000;
  --thirdLightColor: #fff6ea;
  --thirdThBorderColor: #f5d1a1;

  --ant-primary-color: #f59000;
  --ant-primary-color-hover: #edb05c;
  --ant-primary-color-active: #f59000;
  --ant-primary-color-outline: rgba(245, 144, 0, 0.2);
  --ant-primary-1: #fff6ea;
  --ant-primary-2: #f5d1a1;
  --ant-primary-3: #f5d1a1;
  --ant-primary-4: #edb05c;
  --ant-primary-5: #ef9d2b;
  --ant-primary-6: #f59000;
  --ant-primary-7: #f59000;
`;
